import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import ButtonComponent from '../form/buttonComponent';
import { Divider, IconButton, Stack, Typography, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DialogComponent = ({
    open,
    setOpen,
    title,
    body,
    proceedTxt="Submit",
    closeCallback=null,
    proceedCallback=null,
    avoidClose=false
}) => {
    const theme = useTheme();

    const handleClose = React.useCallback(() => {
        if(avoidClose) return;

        if(closeCallback) closeCallback();

        setOpen(false);
    }, [avoidClose]);

    return (
        <React.Fragment>
            <Dialog 
                open={open} 
                onClose={handleClose}
                slotProps={{
                    paper: {
                        sx: {
                            overflow: 'visible'
                        }
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        px: {xs: 3, md: 5},
                        pt: {xs: 3, md: 5}
                    }}
                >
                    <Stack
                        direction='row'
                        justifyContent='space-between'
                        alignItems='center'
                    >
                        <Typography
                            fontWeight={600}
                            fontSize={{xs: 12, md: 14, lg: 16}}
                            textAlign='left'
                            color={theme.palette.text.primary}
                            lineHeight={1.25}
                            pb={2}
                        >
                            {title}
                        </Typography>

                        {
                            avoidClose
                            ?
                            <></>
                            :
                            <IconButton 
                                aria-label="close" 
                                size="small"
                                onClick={handleClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        }
                    </Stack>

                    <Divider sx={{width: '100%'}}/>
                </DialogTitle>

                <DialogContent
                    className='hideScrollBar'
                    sx={{
                        p: {xs: 3, md: 5}
                    }}
                >
                    {body}
                </DialogContent>

                {
                    proceedCallback
                    ?
                    <></>
                    :
                    <DialogActions
                        sx={{
                            p: {xs: 3, md: 5}
                        }}
                    >
                        <ButtonComponent 
                            label={proceedTxt}
                            onClick={proceedCallback}
                        />
                    </DialogActions>
                }
            </Dialog>
        </React.Fragment>
    );
}

export default DialogComponent;